import React from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import _ from 'lodash'
import RenderedHtmlContent from "src/shared/virtual_congress/components/rendered_html_content";

let ThankYouPage = function(props){

  let decline_confirmation_enabled = useSelector(state => state.enable_decline_confirmation)
  let decline_confirmation_text = useSelector(state => state.decline_confirmation_text)
  const tagOwner = useSelector(state => state.tagOwner)

  let thankYouHeadline = props.thankYouHeadline
  let thankYouText = props.thankYouText

  return (
    <div className="r-container pb-4">
      {decline_confirmation_enabled && props.doDecline == true ? (
         <div className="r-header-text" dangerouslySetInnerHTML={{ __html: decline_confirmation_text}}></div>
      ) : (
        <div>
          <h1 className="page-header r-header-headline mb-4 pt-4 col-sm-12 " id="header_headline" dangerouslySetInnerHTML={{ __html: thankYouHeadline}}></h1>
          <RenderedHtmlContent className="r-header-text col-sm-12" html={thankYouText.replace("@tag_owner_id@", tagOwner ? tagOwner.id : "")}/>
        </div>
      )}
    </div>
  )
}
export default ThankYouPage;